(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["countdown"] && !Shopify.designMode) return;
  try {
    (() => {
    const countdowns = document.querySelectorAll('.countdown[data-countdown]');
    if (!countdowns.length) return;

    const getNextEndDate = (targetDay) => {
      const now = new Date();
      const today = now.getDay();
      const target = targetDay === 7 ? 0 : Number(targetDay);
      let delta = target - today;
      if (delta < 0) delta += 7;
      if (delta === 0) {
        const endToday = new Date(now);
        endToday.setHours(23, 59, 59, 999);
        if (endToday.getTime() > now.getTime()) return endToday;
        delta = 7;
      }
      const end = new Date(now);
      end.setDate(now.getDate() + delta);
      end.setHours(23, 59, 59, 999);
      return end;
    };

    const updateCountdown = (countdown) => {
      const dayEnd = Number(countdown.dataset.dayEnd || 7);
      const endDate = getNextEndDate(dayEnd);
      const now = new Date();
      let diff = endDate.getTime() - now.getTime();
      if (diff < 0) diff = 0;

      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const setValue = (key, value) => {
        const node = countdown.querySelector(`[data-countdown-value="${key}"]`);
        if (node) node.textContent = value;
      };

      const setLabel = (key, value) => {
        const node = countdown.querySelector(`[data-countdown-label="${key}"]`);
        if (!node) return;
        const singular = countdown.dataset[`label${key.charAt(0).toUpperCase()}${key.slice(1)}Singular`];
        const plural = countdown.dataset[`label${key.charAt(0).toUpperCase()}${key.slice(1)}Plural`];
        node.textContent = value === 1 ? singular || node.textContent : plural || node.textContent;
      };

      setValue('days', days);
      setValue('hours', String(hours).padStart(2, '0'));
      setValue('minutes', String(minutes).padStart(2, '0'));
      setValue('seconds', String(seconds).padStart(2, '0'));

      setLabel('days', days);
      setLabel('hours', hours);
      setLabel('minutes', minutes);
      setLabel('seconds', seconds);
    };

    countdowns.forEach((countdown) => {
      updateCountdown(countdown);
      if (countdown._countdownInterval) clearInterval(countdown._countdownInterval);
      countdown._countdownInterval = setInterval(() => updateCountdown(countdown), 1000);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product-block-bundle-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    class BundlePicker extends HTMLElement {
      constructor() {
        super();

        this.configScript = null;
        this.bundleConfig = [];
        this.colorConfig = [];
        this.optionMap = null;

        this.boundHandleChange = this.handleChange.bind(this);

      }

      connectedCallback() {
        this.configScript = this.querySelector('script[data-variant]');
        this.configColorScript = this.querySelector('script[data-color]');
        if (!this.configScript) return;

        this.bundleConfig = this.parseConfig(this.configScript);
        this.colorConfig = this.parseConfig(this.configColorScript);
        this.colorMap = new Map(
          this.colorConfig.map((item) => [
            item.name,
            {
              color: item.color,
              label: item.label,
              swatch: item.swatch ? item.swatch[String(item.name).toLocaleLowerCase()] : null,
            },
          ])
        );
        this.optionMap = this.buildOptionMap(this.bundleConfig);

        if (!this.optionMap) return;

        this.render();
        this.bindEvents();
        this.dispatchInitEvent();
      }

      disconnectedCallback() {
        this.unbindEvents();
      }

      render() {
        const container = this.querySelector('.bundle-picker__inner');
        if (!container) {
          console.warn('BundlePicker: .bundle-picker__inner not found');
          return;
        }

        const fragment = document.createDocumentFragment();

        Object.entries(this.optionMap).forEach(([optionName, optionData]) => {
          const normalizedOptionName = this.normalizeOptionName(optionName);
          const relatedSelect = document.getElementById(normalizedOptionName);
          const selectedValue = relatedSelect?.value;

          const fieldset = document.createElement('fieldset');
          fieldset.dataset.optionName = optionName;
          fieldset.setAttribute("hidden", "");

          const legend = document.createElement('legend');
          const small = document.createElement('small');
          small.textContent = '';
          legend.textContent = `${optionName.replace('_', '')}: `;
          legend.appendChild(small);

          fieldset.appendChild(legend);
          optionData.values.forEach((value, index) => {
            const id = `${normalizedOptionName}-${index}`;

            const input = document.createElement('input');
            input.type = 'radio';
            input.name = normalizedOptionName;
            input.value = value;
            input.id = id;

            if (selectedValue === value) {
              input.checked = true;
            }

            const labelColor = optionData.colors[index] || value;
            const colorInMap = this.colorMap.get(labelColor);
            
            if(!colorInMap) return;

            input.setAttribute('data-label', colorInMap.label || labelColor);
            const label = document.createElement('label');
            label.setAttribute('for', id);
            const span = document.createElement('span');
            if (label && colorInMap && colorInMap.color) {
              span.style.setProperty('--swatch', colorInMap.color);
              label.classList.add('is-swatch');
              if (colorInMap.swatch) {
                span.style.setProperty('--swatch-image', `url(${colorInMap.swatch})`);
                label.classList.add('is-swatch--image');
              }
            }
            span.textContent = optionData.colors[index] || value;
            label.append(span);
            fieldset.append(input, label);
            fieldset.removeAttribute("hidden");
          });

          const allInputs = fieldset.querySelectorAll("input");
          allInputs.forEach(input => input.checked = false );
          if (!fieldset.querySelector('input:checked')) {
            const firstInput = fieldset.querySelector('input');
            if (firstInput) firstInput.checked = true;
          }

          fragment.appendChild(fieldset);
        });

        container.appendChild(fragment);
      }

      bindEvents() {
        this.addEventListener('change', this.boundHandleChange);
      }

      unbindEvents() {
        this.removeEventListener('change', this.boundHandleChange);
      }

      handleChange(event) {
        const input = event.target;
        if (input.type !== 'radio') return;

        const fieldset = input.closest('fieldset');
        if (!fieldset) return;

        const optionName = fieldset.dataset.optionName;
        const normalizedOptionName = this.normalizeOptionName(optionName);

        this.syncSelect(normalizedOptionName, input.value);

        this.dispatchChangeEvent({
          optionName,
          value: input.value,
          inputElement: input,
        });
      }

      syncSelect(optionKey, value) {
        const select = this.offsetParent.querySelector('#' + CSS.escape(optionKey));
        if (!select) return;

        if (select.value !== value) {
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      dispatchInitEvent() {
        queueMicrotask(() => {
          this.dispatchEvent(
            new CustomEvent('bundle-picker:init', {
              bubbles: true,
              detail: {
                optionMap: this.optionMap,
              },
            })
          );
        });
      }

      dispatchChangeEvent(detail) {
        this.dispatchEvent(
          new CustomEvent('bundle-picker:change', {
            bubbles: true,
            detail: {
              ...detail,
              optionMap: this.optionMap,
            },
          })
        );
      }

      parseConfig(scriptTag) {
        try {
          return JSON.parse(scriptTag.textContent) || [];
        } catch (error) {
          console.error('BundlePicker: Invalid JSON config', error);
          return [];
        }
      }

      buildOptionMap(config = []) {
        if (!Array.isArray(config) || !config.length) return null;

        const optionMap = {};

        config.forEach(({ optionName, optionValues }) => {
          if (!optionName || !optionValues) return;

          const values = String(optionValues)
            .split(',')
            .map((v) => v.trim())
            .filter(Boolean);

          if (values.length < 2) return;

          optionMap[optionName] = { values };
          optionMap[optionName].colors = [];
          values.forEach((value) => {
            const normalizedValue = value
              .split('-')
              .map((element) => element.trim().toLocaleLowerCase())
              .splice(1)
              .join('-');
            optionMap[optionName].colors.push(normalizedValue);
          });
        });

        return optionMap;
      }

      changeLagendText() {
        this.querySelectorAll('fieldset').forEach((fieldset) => {
          const labelValue = fieldset.querySelector('legend small');
          const checkedInput = fieldset.querySelector('input:checked');

          if(!labelValue || !checkedInput ) return;

          const {
            dataset: { label },
          } = checkedInput;
          if (label && labelValue) labelValue.textContent = label;
        });
      }

      normalizeOptionName(name = '') {
        return name.trim().toLowerCase().replaceAll(' ', '-');
      }
    }

    if (!customElements.get('bundle-picker')) {
      customElements.define('bundle-picker', BundlePicker);
    }

    const pickers = document.querySelectorAll('.bundle-picker');

    pickers.forEach((picker) => {
      if (!picker) return;

      const updateLegendText = () => {
        picker.changeLagendText?.call(picker);
      };

      const updateBundleSelectionInput = (event) => {
        updateLegendText();

        const root = event?.target?.offsetParent;
        if (!root) return;

        const bundleInput = root.querySelector('.bundle-app-selector input[name="properties[_bundle_selection]"]');
        if (!bundleInput) return;

        const selects = root.querySelectorAll('.bundle-app-selector select');
        const values = [...selects].map((select) => select.value).filter(Boolean);

        bundleInput.value = values.join(' <> ');
      };

      picker.addEventListener('bundle-picker:init', updateLegendText);
      picker.addEventListener('bundle-picker:change', updateBundleSelectionInput);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
